import React from "react";
import PropTypes from "prop-types";

import FontClass from "@components/asset/shared/fontClass";
import ReactPlayerLoader from '@brightcove/react-player-loader';
import CustomFieldsAccordion from "./customFieldsAccordion";
import PersonDetails from "./personDetails";
import AssetTags from './assetTags';

/* NOTE : Anytime you do work in this component make sure there is parody within
the orgSearchResultsAssetDetails component. At some point these should become one
component. Right now they are separated because this component is getting the majority
of it's information from rails, whereas the orgSearchResultsAssetDetails is
getting it's information from an ajax call, which at this point is not sufficient
to recieve the infomation and do all the actions we need */

class AssetDetails extends React.Component {
  get brandfolder() {
    return BF.fx.brandfolder();
  }

  get collection() {
    return BF.fx.collection();
  }

  get assetBackgroundColor() {
    const backgroundColor = this.props.backgroundColor;
    return backgroundColor && backgroundColor !== "default"
      ? { background: backgroundColor }
      : { backgroundColor: "transparent" };
  }

  renderAssetSpecificDescription() {
    const { asset, assetData } = this.props;

    switch (asset.type) {
      case "Person":
        return (
          <PersonDetails
            email={assetData.email}
            linkedin={assetData.linkedin}
            name={asset.name}
            phoneNumber={assetData.phone_number}
            title={assetData.title}
            twitter={assetData.twitter}
          />
        );
      case "Press":
        return (
          <div className="m-show-description">
            {asset.url ? (
              <a href={asset.url} target="blank">
                {" "}
                {asset.url}
              </a>
            ) : (
              ""
            )}
            {asset.published_date ? <div> {asset.published_date} </div> : ""}
          </div>
        );
      default:
        break;
    }
    return undefined;
  }

  renderHeader() {
    const { asset, elementDisplay, threeSixtyViewer } = this.props;

    if (elementDisplay) {
      if (asset.type === "Color") {
        return (
          <div
            className="s-color-bg-show"
            style={{ backgroundColor: elementDisplay }}
          />
        );
      }

      if (elementDisplay.startsWith('brightcove|')) {
        const accountID = elementDisplay.split('|')[1];
        const videoID = elementDisplay.split('|')[2];

        if (videoID && videoID.length) {
          return (
            <ReactPlayerLoader
              attrs={{
                id: "advanced-video",
                className: "m-show-full-size-display"
              }}
              accountId={accountID}
              videoId={videoID}
              playerId="default"
            />
          );
        }

        // Special placeholder video and player
        return (
          <ReactPlayerLoader
            attrs={{
              id: "advanced-video",
              className: "m-show-full-size-display processing"
            }}
            accountId={accountID}
            videoId={6045002940001}
            playerId="OV7Vi4enS"
          />
        );
      }

      let previewHtml = elementDisplay;
      const hasATag = elementDisplay.indexOf('</a>') > 0;

      if (hasATag) {
        const firstTag = elementDisplay.split('</a>')[0];
        const newTagHtml = '<div class="attachment-icons"><span class="bff-new-tab"/></div></a>';
        previewHtml = `${firstTag}${newTagHtml}`;
      }

      if (threeSixtyViewer) {
        return (
          <div className="m-show-full-size-display">
            <div id="three-sixty-viewer" />
          </div>
        );
      }

      const stretchClass = (asset.type !== "ExternalMedium" && hasATag) ? "stretch" : "";
      const videoClass = asset.type === "ExternalMedium" ? "external-medium-container" : "";

      return (
        <React.Fragment>
          <div
            className={`m-show-full-size-display ${stretchClass} ${videoClass}`}
            style={this.assetBackgroundColor}
            dangerouslySetInnerHTML={{ __html: previewHtml }}
          />
        </React.Fragment>

      );
    }

    if (asset.type === "Font") {
      return (
        <div className="m-show-full-size-display">
          <FontClass asset={asset}>
            Aa Bb Cc Dd Ee Ff Gg Hh Jj Kk Ll Mm Nn Oo Pp Qq Rr Ss Tt Uu Vv
            Ww Xx Yy Zz 0123456789
          </FontClass>
        </div>
      );
    }

    return undefined;
  }

  render() {
    const {
      approvedBy,
      awaitingApproval,
      collectionExpiration,
      customFields,
      expired,
      expirationDate,
      formattedDescription,
      publishDate,
      tags,
      unpublished,
      updatedAndCreated
    } = this.props;

    return (
      <React.Fragment>
        {this.renderHeader()}
        {updatedAndCreated ? (<div dangerouslySetInnerHTML={{ __html: updatedAndCreated }} />) : ("")}
        {approvedBy ? (<div dangerouslySetInnerHTML={{ __html: approvedBy }} />) : ("")}
        {awaitingApproval ? (<div dangerouslySetInnerHTML={{ __html: awaitingApproval }} />) : ("")}
        {collectionExpiration ? (<div dangerouslySetInnerHTML={{ __html: collectionExpiration }} />) : ("")}

        {publishDate
          ? (
            <div className="s-modal-published-on">
              {`${unpublished ? t("Will Publish on") : t("Published on")} ${publishDate}`}
            </div>
          ) : ("")
        }

        {expirationDate ? (
          <div className="s-modal-expires-on">
            {`${expired ? t("Expired on") : t("Expires on")} ${expirationDate}`}
          </div>
        ) : ("")}

        {tags.length > 0 ? <AssetTags tags={tags} orgSearchPage={false} /> : ""}

        {this.renderAssetSpecificDescription()}

        {formattedDescription ? (
          <div className="m-show-description s-asset-description">
            <span className="s-asset-details-title modal-label">{t('Description')}</span>
            <p dangerouslySetInnerHTML={{ __html: this.props.formattedDescription }} />
          </div>
        ) : (
          ""
        )}

        {customFields && Object.keys(customFields).length > 0 ? (
          <CustomFieldsAccordion count={6} customFields={customFields} />
        ) : (
          ""
        )}

      </React.Fragment>
    );
  }
}

AssetDetails.propTypes = {
  approvedBy: PropTypes.string,
  asset: PropTypes.shape({}).isRequired,
  assetData: PropTypes.shape({}),
  awaitingApproval: PropTypes.string,
  backgroundColor: PropTypes.string,
  collectionExpiration: PropTypes.string,
  customFields: PropTypes.shape({}).isRequired,
  elementDisplay: PropTypes.string,
  expired: PropTypes.bool.isRequired,
  expirationDate: PropTypes.string,
  formattedDescription: PropTypes.string,
  publishDate: PropTypes.string,
  tags: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  threeSixtyViewer: PropTypes.bool,
  unpublished: PropTypes.bool.isRequired,
};

AssetDetails.defaultProps = {
  approvedBy: '',
  assetData: {},
  awaitingApproval: '',
  backgroundColor: '',
  collectionExpiration: '',
  elementDisplay: '',
  expirationDate: '',
  formattedDescription: '',
  publishDate: '',
  threeSixtyViewer: false,
};

export default AssetDetails;
